import { useFeatureFlagsQuery } from "@common/utils/graphql";
import { useUserStore } from "@domains/auth/utils/useUserStore";
import { useMemo } from "react";

export const useFeatureFlags = () => {
  const organizationId = useUserStore((state) => state.organizationId);
  const { data: featureFlagsData } = useFeatureFlagsQuery({
    skip: !organizationId,
    variables: organizationId ? { organizationId } : undefined,
  });

  const maybeFeatureFlags = useMemo(
    () =>
      featureFlagsData?.organizationalFeatureFlags.__typename ===
      "QueryOrganizationalFeatureFlagsSuccess"
        ? featureFlagsData.organizationalFeatureFlags.data
        : null,
    [featureFlagsData],
  );

  return {
    isDelegateUsersEnabled: maybeFeatureFlags?.hypercardDelegatesShown ?? false,
  };
};
